import { StyleSheet } from 'react-native';
import { DynamicStyleSheet, variants } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  root: {
    backgroundColor: theme.colors.cardBG,
    borderRadius: Platform.select({
      ios: theme.radii.ios,
      android: theme.radii.android,
      default: theme.radii.web,
    }),
    ...variants({
      elevated: {
        ...theme.shadows.m,
      },
      outlined: {
        borderWidth: StyleSheet.hairlineWidth,
        borderColor: theme.colors.cardBorder,
      },
    }),
  },
}));
